import { ToastStore } from '@gem/popups';

import { Appearance } from 'STORE/Appearance/Appearance';
import { FeaturesStore } from 'STORE/FeaturesStore/FeaturesStore';
import { ViewportMessages } from 'STORE/ViewportMessages/ViewportMessages';
import { Workspace } from 'STORE/Workspace/Workspace';

import { App } from './App/App';
import { AuthStore } from './AuthStore/AuthStore';
import { BackgroundCalls } from './BackgroundCalls/BackgroundCalls';
import { CachedImages } from './CachedImages/CachedImages';
import { Calendar } from './Calendar/Calendar';
import { CallInvitation } from './CallInvitation/CallInvitation';
import { Calls } from './Calls/Calls';
import { CatalogStore } from './CatalogStore/CatalogStore';
import { ClientConfig } from './ClientConfig/ClientConfig';
import { CountersStore } from './CountersStore/CountersStore';
import { Feedback } from './Feedback';
import { GlobalVideoPlayer } from './GlobalVideoPlayer/GlobalVideoPlayer';
import { Groups as GroupsStore } from './Groups/Groups';
import { IncomingCalls } from './IncomingCalls/IncomingCalls';
import { InputPanelsStore } from './InputPanelsStore';
import { ActiveStream } from './LiveStreaming/ActiveStream';
import { BackgroundStreams } from './LiveStreaming/BackgroundStreams';
import { Marketplace } from './Marketplace/Marketplace';
import { MiniAudioPlayer } from './MiniAudioPlayer/MiniAudioPlayer';
import { Newsfeed } from './Newsfeed/Newsfeed';
import { Onboarding } from './Onboarding/Onboarding';
import { PrivacySettings } from './PrivacySettings/PrivacySettings';
import { PushNotifications } from './PushNotifications/PushNotifications';
import { ReactionsStore } from './ReactionsStore/ReactionsStore';
import { Rewards } from './Rewards/Rewards';
import { RightSidebarStore } from './RightSidebarStore/RightSidebarStore';
import { ScheduledEvents } from './ScheduledEvents/ScheduledEvents';
import { Sessions } from './Sessions/Sessions';
import { SpacesStore } from './Spaces/Spaces';
import { Stickers } from './Stickers/Stickers';
import { UserPreferences } from './UserPreferences/UserPreferences';
import { UsersStore } from './Users/Users';
import { ChatStore } from './ViewModels/ChatStore';

export class Root {
  constructor() {
    this.App = new App();
    this.featuresStore = new FeaturesStore();
    this.authStore = new AuthStore();
    this.CachedImages = new CachedImages();
    this.Counters = new CountersStore();
    this.GroupsStore = new GroupsStore(this);
    this.spacesStore = new SpacesStore();
    this.usersStore = new UsersStore();
    this.viewportMessages = new ViewportMessages();
    this.stickersStore = new Stickers();
    this.pushNotifications = new PushNotifications();
    this.InputPanelsStore = new InputPanelsStore(this);
    this.clientConfig = new ClientConfig();
    this.userPreferences = new UserPreferences();
    this.feedback = new Feedback();
    this.rewards = new Rewards();
    this.sessionsStore = new Sessions(this);
    this.calendar = new Calendar();
    this.callInvitation = new CallInvitation();
    // incoming calls store init has to go before calls store init
    // in order to keep correct order of reactions
    this.IncomingCalls = new IncomingCalls(this);
    this.BackgroundCalls = new BackgroundCalls();
    this.Calls = new Calls(this);
    this.appearance = new Appearance();
    this.PrivacySettings = new PrivacySettings();
    this.onboarding = new Onboarding();
    this.marketplace = new Marketplace();
    this.newsfeed = new Newsfeed();
    this.catalogStore = new CatalogStore();
    this.reactionsStore = new ReactionsStore();

    this.workspace = new Workspace();

    this.BackgroundStreams = new BackgroundStreams();
    this.ActiveStream = new ActiveStream();

    this.GlobalVideoPlayer = new GlobalVideoPlayer();
    this.miniAudioPlayer = new MiniAudioPlayer();
    this.scheduledEvents = new ScheduledEvents();
    // ViewModels
    this.ChatStore = new ChatStore(this);
    this.RightSidebar = new RightSidebarStore(this);
    this.toast = ToastStore;
    this.initReactionsExplicitly();
  }

  initReactionsExplicitly() {
    for (const store in this) {
      if (this[store].initReactions) {
        this[store].initReactions();
      }
    }
  }

  reset() {
    for (const store in this) {
      if (this[store].reset) {
        this[store].reset();
      }
    }
  }
}

const stores = new Root();

// Todo add feature flag
window.Entities = stores;

export default stores;
